import { render, staticRenderFns } from "./revisionesPendientes.vue?vue&type=template&id=76eeca56&scoped=true"
import script from "./revisionesPendientes.vue?vue&type=script&lang=js"
export * from "./revisionesPendientes.vue?vue&type=script&lang=js"
import style0 from "./revisionesPendientes.vue?vue&type=style&index=0&id=76eeca56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76eeca56",
  null
  
)

export default component.exports